import urls from "../../../../global/constants/UrlConstants";
import {
  getCallParams,
  getNoAuthCallParams,
  makeCall,
} from "../../../../utils/service";

export async function getAllUsers() {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.GETALLPROJECT, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
export async function getAllUnmappedProject(payload: any) {
  try {
    const callParams = await getCallParams("GET");
    const params = new URLSearchParams({
      page: String(payload.pageNumber ?? 0),
      limit: String(payload.pageSize ?? 25),
      search: payload.search || "",
      portalsOnly: "1",
      bucket: "open",
    });
    if (payload.portal && payload.portal !== "all") {
      params.set("portal", payload.portal);
    }
    const response = await makeCall(
      `${urls.UNMAPPEDPROJECT}?${params.toString()}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}

export async function getDateWiseTeam(
  userId: string,
  from: string,
  to: string
) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(
      urls.GETALLUSER + `?id=${userId}&start_date=${from}&end_date=${to}`,
      callParams
    );
    return response;
  } catch (error) {
    throw error;
  }
}
export async function postOfficeDetails() {
  try {
    const callParams = await getCallParams("POST");
    const response = await makeCall(urls.ADDUSEROFFICE, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function changeUserPassword(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.EDITPASSWORD, callParams);
    return response;
  } catch (error: any) {
    throw error;
  }
}

export async function handelNewProjectAdd(payload: any) {
  try {
    const callParams = await getCallParams("POST", payload);
    const response = await makeCall(urls.ADDPROJECTAPINEW, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function handelExistingProjectAdd(payload: any) {
  try {
    const callParams = await getCallParams("PUT", payload);
    const response = await makeCall(urls.UPDATEPROJECTAPIEXISTING, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}

export async function movingProject(id: any) {
  try {
    const callParams = await getCallParams("GET");
    const response = await makeCall(urls.MOVEPROJECT + `/${id}`, callParams);
    return response;
  } catch (error) {
    throw error;
  }
}
